let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ckx79")).then(() => parcelRequire('eGJ8h'));